// extracted by mini-css-extract-plugin
module.exports = {"flex-container":"Flex_flex-container__AjmXw","flex-container-row":"Flex_flex-container-row__3jB09","flex-container-column":"Flex_flex-container-column__3rrqK"};